import { Link } from 'react-router-dom';

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  desc?: string;
  href?: string;
  hrefLabel?: string;
};

export default function SectionHeading({ eyebrow, title, desc, href, hrefLabel }: SectionHeadingProps) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-primary-600 uppercase mb-3">
            <span className="w-6 h-px bg-primary-400"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {desc && <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">{desc}</p>}
      </div>
      {href && hrefLabel && (
        <Link
          to={href}
          className="inline-flex items-center gap-1 px-4 py-2 rounded-md border border-background-300 text-sm font-medium text-foreground-800 whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer self-start md:self-auto"
        >
          {hrefLabel}
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}